<template>
  <el-dialog
    :title="form2.channelId ? '编辑渠道' : '添加渠道'"
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
  >
    <el-form :model="form2" :rules="rules" ref="form2">
      <el-form-item
        label="渠道名称"
        :label-width="formLabelWidth"
        prop="channelName"
      >
        <el-input
          v-model="form2.channelName"
          autocomplete="off"
          placeholder="请输入渠道名称"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="渠道类型"
        :label-width="formLabelWidth"
        prop="productId"
      >
        <el-select
          v-model="form2.productId"
          filterable
          placeholder="请选择渠道类型"
          :disabled="isDisabled"
        >
          <el-option label="代收" value="110"></el-option>
          <el-option label="代付" value="120"></el-option>
          <!-- <el-option
            v-for="item in channelOption"
            :key="item.productId"
            :label="item.productName"
            :value="item.productId"
          ></el-option> -->
        </el-select>
      </el-form-item>

      <el-form-item
        label="实现类名称"
        :label-width="formLabelWidth"
        prop="serviceImplName"
      >
        <el-input
          v-model="form2.serviceImplName"
          autocomplete="off"
          placeholder="请输入实现类名称"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="交易状态"
        prop="channelStatus"
        :label-width="formLabelWidth"
        required
      >
        <el-col :span="24">
          <el-select v-model="form2.channelStatus" placeholder="交易状态">
            <el-option key="" label="--请选择--" value=""></el-option>
            <el-option key="00" label="开通" value="00"></el-option>
            <el-option key="01" label="关闭" value="01"></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item
        label="最小交易金额"
        :label-width="formLabelWidth"
        prop="minAmount"
      >
        <el-input
          v-model="form2.minAmount"
          autocomplete="off"
          placeholder="请输入最小交易金额"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="最大交易金额"
        :label-width="formLabelWidth"
        prop="maxAmount"
      >
        <el-input
          v-model="form2.maxAmount"
          autocomplete="off"
          placeholder="请输入最大交易金额"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="优先级"
        :label-width="formLabelWidth"
        prop="rate"
      >
        <el-input
          v-model="form2.priority"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="费率"
        :label-width="formLabelWidth"
        prop="rate"
      >
        <el-input
          v-model="form2.rate"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label=" 配置信息"
        :label-width="formLabelWidth"
        prop="channelConfig"
      >
        <el-input
          v-model="form2.channelConfig"
          type="textarea"
          :rows="5"
          placeholder="请输入JSON字符串"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveSystem" v-if="isButton"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'channelEdit',
  props: {
    show: Boolean,
    value: Object,
    action: String,
    channelOption: Array,
  },
  data() {
    return {
      dialogShow: this.show,
      groups: '',
      isButton: true,
      isDisabled: false,
      time: { start: '00:00', step: '00:05', end: '23:59' },
      form2: {
        channelName: '',
        channelStatus: '00',
        serviceImplName: '',
        channelCost: '',
        channelConfig: '',
        channelId: '',
        rate: '',
        fee: '',
        minAmount: '1',
        maxAmount: '50000',
        tranStartTime: '00:00',
        tranEndTime: '00:00',
        productId: '',
        priority: '1',
      },
      formLabelWidth: '120px',
      rules: {
        channelName: [
          {
            required: true,
            message: '请输入渠道名称',
            trigger: ['blur', 'change'],
          },
          {
            min: 1,
            max: 20,
            message: '请输入1到20个字母',
            trigger: ['blur', 'change'],
          },
        ],
        channelStatus: [
          {
            required: true,
            message: '请选择交易状态',
            trigger: ['blur', 'change'],
          },
        ],
        serviceImplName: [
          {
            required: true,
            message: '请输入实现类名称',
            trigger: ['blur', 'change'],
          },
        ],
        channelCost: [
          {
            required: true,
            message: '请输入渠道成本',
            trigger: ['blur', 'change'],
          },
        ],
        channelConfig: [
          {
            required: true,
            message: '请输入配置信息',
            trigger: ['blur', 'change'],
          },
        ],
        productId: [
          {
            required: true,
            message: '请选择渠道类型',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  methods: {
    init() {
      if (this.action == 'edit') {
        this.form2 = Object.assign({}, this.value)
        this.form2.minAmount = this.$formatter.FenToYuan(
          null,
          null,
          this.value.minAmount,
          null
        )
        this.form2.maxAmount = this.$formatter.FenToYuan(
          null,
          null,
          this.value.maxAmount,
          null
        )
      }
    },
    closeDialog() {
      // this.dialogShow = false;
      this.form2 = {
        channelName: '',
        channelStatus: '00',
        serviceImplName: '',
        channelCost: '',
        channelConfig: '',
        channelId: '',
        rate: '',
        fee: '',
        minAmount: '1',
        maxAmount: '50000',
        tranStartTime: '00:00',
        tranEndTime: '00:00',
        productId: '',
        priority: '1',
      }
      this.$refs['form2'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },
    saveSystem() {
      this.$refs['form2'].validate(valid => {
        if (valid) {
          let url = '/routeChannelInfo/routeChannelInfoAdd'
          if (this.action === 'edit') {
            url = '/routeChannelInfo/routeChannelInfoUpdate'
          }

          this.axios.post(url, this.form2).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'success',
              })
              // this.$bus.$emit('refresh') //通知刷新

              this.closeDialog()
            } else {
              this.$notify.error({
                title: '提示',
                message: res.msg,
              })
            }
          })
        } else {
          return false
        }
      })
    },
  },
  // watch: {
  //   show(newVal) {
  //     this.dialogShow = newVal;
  //   },
  //   value(newVal) {
  //     this.form2 = Object.assign({}, newVal);
  //     this.form2.fee = this.form2.fee;
  //     this.form2.minAmount = this.$formatter.Fen2Yuan(
  //       null,
  //       null,
  //       this.form2.minAmount,
  //       null
  //     );
  //     this.form2.maxAmount = this.$formatter.Fen2Yuan(
  //       null,
  //       null,
  //       this.form2.maxAmount,
  //       null
  //     );
  //     console.log(this.form2);
  //     if (this.$refs.form2 !== undefined) {
  //       this.$refs.form2.clearValidate();
  //     }
  //   },
  // },
  mounted() {
    this.$bus.$on('refreshButton', isButton => {
      this.isButton = isButton
    }),
      this.$bus.$on('isDisabled', isDisabled => {
        this.isDisabled = isDisabled
      }),
      this.$bus.$on('dialogShow', dialogShow => {
        this.dialogShow = dialogShow
      })
  },
}
</script>

<style scoped>
</style>